import { render, staticRenderFns } from "./OriginDropdown.vue?vue&type=template&id=a9ab2ed6&"
import script from "./OriginDropdown.vue?vue&type=script&lang=js&"
export * from "./OriginDropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports